<template>
  <v-card
    flat
    :style="
      $vuetify.breakpoint.mdOnly ? 'width: calc(100vw - 240px); overflow-x:auto; white-space: nowrap;' : 'width:1120px'
    ">
    <v-tabs v-model="tab" grow>
      <v-tab v-for="item in items" :key="item.tab">
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in items" :key="item.tab">
        <v-card flat>
          <component :is="item.content"></component>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import userMixin from '@/components/shared/userMixin';
import campaignMixin from '@/components/shared/campaignMixin';

export default {
  name: 'Charge',
  mixins: [userMixin, campaignMixin],
  data() {
    return {
      tab: null,
      items: [
        { tab: '결제하기', content: () => import('@/components/campaign/charge/Payment') },
        { tab: '결제 내역', content: () => import('@/components/campaign/charge/History') },
      ],
    };
  },
  watch: {},
  methods: {},
  created() {},
};
</script>

<style scoped lang="scss"></style>
